import { OpenFeatureProvider } from '@openfeature/react-sdk'
import { ReactNode } from 'react'

import { useEnsureRemoteFeatureFlags } from './useEnsureRemoteFeatureFlags'

interface RemoteFeatureFlagProviderProps {
  children: ReactNode
}

export const RemoteFeatureFlagProvider = ({ children }: RemoteFeatureFlagProviderProps) => {
  useEnsureRemoteFeatureFlags()

  return <OpenFeatureProvider>{children}</OpenFeatureProvider>
}
